<script lang="ts">
    
    import { onMount } from "svelte";
    import type { FigureName as FigureNameType, GameType } from "../../global";    
    import type { Player } from "../../Model/Player";
    import PlayerBar from "../Player/PlayerBar.svelte";
    import FigureName from "../Shared/FigureName.svelte";
    import AwardTitle from "./AwardTitle.svelte";
    import Confetti from "./Confetti.svelte";

    export let showConffeti = false;
    export let player: Player;
    export let figureName: FigureNameType | 'bingo';
    export let rewardMessage: string;
    export let gameType: GameType;

    const volume = 0.7;
    const awardImagesMap: Record<GameType, string> = {
        'Bingo75'               : '/images/award/bingo_75.png',
        'Bingo90'               : '/images/award/bingo_90.png',
        'BingoMex'              : '/images/award/bingo_mex.png',
        'BingoAnimals'          : '/images/award/binfun.png',
        'BingoCartoon'          : '/images/award/binfun.png',
        'Movies'                : '/images/award/binfun.png',
        'XMas'                  : '/images/award/binfun.png',
        'MoviesKids'            : '/images/award/binfun.png',
        'Football'              : '/images/award/binfun.png',
        'Halloween'             : '/images/award/binfun.png',
        'Superheroes'           : '/images/award/binfun.png',
        'Cartoon'               : '/images/award/binfun.png'
    };

    let awardSound: HTMLAudioElement;

    onMount(() => {
        awardSound.volume = volume;
        awardSound.play();
    });

</script>

<audio style="display: none;" src="/sound/award.mp3" preload="auto" bind:this={awardSound} />

<div class="award-screen">
    
    {#if showConffeti}
        <div class="conffeti">
            <Confetti />
        </div>
    {/if}

    <div class="award">
        {#if figureName === 'bingo'}
            <img class="game-type" src={awardImagesMap[gameType]} alt="">
        {:else}
            <FigureName name={figureName} let:text={title}>
                <AwardTitle {title} />
            </FigureName>
        {/if}
        <PlayerBar {player} invert />
        <div class="reward">{rewardMessage}</div>
    </div>

</div>

<style lang="scss">

    .award-screen {
        position: fixed;
        z-index: 999;
        top: 0;
        left: 0;
        width: 100vw;
        height: var(--vh, 100vh);
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .conffeti {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .award {
        position: relative;
        z-index: 2;
        max-width: 300px;
        display: flex;
        gap: 1rem;
        flex-direction: column;
        align-items: center;
    }

    .game-type {
        max-width: 100%;
    }

    .reward {
        font-size: 1.3rem;
        text-align: center;
    }

</style>
